import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkModeKey = 'darkMode';
  private darkModeSubject: BehaviorSubject<boolean>;
  public darkMode$: Observable<boolean>;

  constructor() {
    // Check localStorage or system preference
    const savedMode = localStorage.getItem(this.darkModeKey);
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isDark = savedMode ? savedMode === 'true' : prefersDark;

    this.darkModeSubject = new BehaviorSubject<boolean>(isDark);
    this.darkMode$ = this.darkModeSubject.asObservable();

    // Apply initial mode
    this.applyTheme(isDark);

    // Listen for system theme changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem(this.darkModeKey)) {
        this.setDarkMode(e.matches);
      }
    });
  }

  isDarkMode(): boolean {
    return this.darkModeSubject.value;
  }

  setDarkMode(isDark: boolean): void {
    localStorage.setItem(this.darkModeKey, isDark.toString());
    this.darkModeSubject.next(isDark);
    this.applyTheme(isDark);
  }

  toggleDarkMode(): void {
    this.setDarkMode(!this.isDarkMode());
  }

  private applyTheme(isDark: boolean): void {
    if (isDark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }
}
